import React, { useEffect, useState } from 'react';
import './Preloader.css';

export const Preloader = () => {
    const [visible, setVisible] = useState(true);
    const [fadeOut, setFadeOut] = useState(false);

    useEffect(() => {
        // Start fade-out after 1.8s, then fully remove after transition
        const fadeTimer = setTimeout(() => setFadeOut(true), 1800);
        const removeTimer = setTimeout(() => setVisible(false), 2350);
        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(removeTimer);
        };
    }, []);

    if (!visible) return null;

    return (
        <div className={`preloader${fadeOut ? ' preloader--hidden' : ''}`}>
            <div className="preloader__inner">
                {/* Animated rings */}
                <div className="preloader__ring">
                    <div></div><div></div><div></div><div></div>
                </div>
                {/* Logo / brand */}
                <div className="preloader__logo">
                    <img src={require('../assets/images/logo.png')} alt="ASM Wedding Cards" />
                </div>
                <p className="preloader__text">Loading<span>.</span><span>.</span><span>.</span></p>
            </div>
        </div>
    );
};
